import { useMemo } from 'react';
import { useAppAuth } from './useAppAuth';
import { deriveUserRoleGates, type UserRoleGates } from './userRoleGates';

export type { UserRoleGates };

/**
 * The current user's tenant roles and the gates we check on them.
 *
 * One implementation so the sidebar, the home page and a page's own read-only
 * mode agree — they were copy-pasted before, which is how they drifted. The
 * logic itself lives in userRoleGates.ts as a plain function.
 */
export function useUserRoles(): UserRoleGates {
  const { user } = useAppAuth();
  return useMemo(() => deriveUserRoleGates(user?.roles), [user]);
}
